<template>
  <div class="container-fluid mt-3">
    <ValidationObserver ref="evaluationInformationForm">
      <SectionTitle :has-line="true" content="Información de Evaluaciones" />

      <div class="row d-flex justify-content-start">
        <div class="d-flex">
          <custom-balloon
            class="ml-3 px-3"
            text="Pendiente a Discusión"
            background-color="balloon-container pending"
          />
        </div>
      </div>
      <template
        v-if="
          evaluationInformationLayout.evaluationInformationData.length == 0 ||
            evaluationInformationLayout.evaluationInformationData.filter(
              (x) => x.validForDiscussion
            ).length == 0
        "
      >
        <div
          class="row d-flex justify-content-center mt-3 container-info-unaviable  evaluetion-unaviable"
        >
          <span class="no-info-text ">
            <p class="p-no-info">
              No cuenta con evaluaciones disponibles para discusión.
            </p>
          </span>
        </div>

        <div v-if="!validate" class="row d-flex justify-content-start mt-2">
          <div class="d-flex">
            <div class="col-md-12 col-sm-12 p-3 ml-1">
              <ErrorComponent
                v-if="!validate"
                message="Es necesario que seleccione al menos una evaluación durante la discusión."
                variant="withoutspacing"
              />
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="row d-flex justify-content-start mt-2">
          <div class="col-12 mt-3">
            <div>
              <EvaluationInformationRow
                v-for="evaluation in evaluationList"
                :key="evaluation.studentEvaluationId"
                :ref="
                  `evaluation-information-row-${evaluation.studentEvaluationId}`
                "
                class=" align-left"
                :items-eval="evaluation"
                :discussion-statuses="discussionStatuses"
                :rejection-reasons="rejectionReasons"
                :is-submitted="isSubmitted"
                :show-error="showError"
                @remove-rejection="onRemoveRejection(evaluation, $event)"
                @add-rejection="onAddRejection(evaluation, $event)"
                @on-delete="removeEvaluation(evaluation)"
                @on-determine-change="onDetermineChange(evaluation, $event)"
                @on-discussion-status-change="
                  onDiscussionStatusChange(evaluation, $event)
                "
                @on-push-comments="onPushComments(evaluation, $event)"
              />
            </div>
          </div>
        </div>
      </template>
      <br />
      <div v-if="isMobile" class="row resizer">
        <div class="col-md-10 col-sm-12 pb-3">
          <action-button
            v-if="!isSubmitted"
            type="submit"
            text="Seleccionar otras evaluaciones"
            i="fa fa-edit pl-2"
            variant="outline-success btn-block"
            class="px-2 mr-2 actions"
            @click="openCloseSelectManyEvaluations"
          />
        </div>
        <div class="col-md-2 col-sm-12 pb-3">
          <action-button
            v-if="!isSubmitted"
            type="submit"
            text="Añadir"
            i="fa fa-file-plus pl-2"
            variant="success btn-block"
            class="px-1 actions"
            @click="addEvaluationHandler"
          />
        </div>
      </div>
      <div v-if="!isMobile" class="row resizer">
        <div class="d-flex justify-content-end col-md-12 col-sm-12 pb-3">
          <action-button
            v-if="!isSubmitted"
            type="submit"
            text="Seleccionar otras evaluaciones"
            i="fa fa-edit pl-2"
            variant="outline-success"
            class="px-2 mr-2 actions"
            @click="openCloseSelectManyEvaluations"
          />
          <action-button
            v-if="!isSubmitted"
            type="submit"
            text="Añadir"
            i="fa fa-file-plus pl-2"
            variant="success "
            class="px-1 actions"
            @click="addEvaluationHandler"
          />
        </div>
      </div>
      <div v-if="selectManyEvaluationsOpened">
        <select-many-evaluations
          ref="selectManySelection"
          :evaluations="availables"
          :selected-evaluations="selectedEvaluations"
          @cancel-select-many="openCloseSelectManyEvaluations"
          @continue-select-many="onContinueHandler"
        />
      </div>
      <div class="row d-flex justify-content-start mt-2">
        <div class="d-flex">
          <custom-balloon
            class="ml-3 px-3"
            text="Evaluación a Recomendar"
            background-color="balloon-container recommend"
          />
        </div>
      </div>
      <template v-if="!hasRecommendedEvaluations">
        <div
          class="row d-flex justify-content-center mt-3 container-info-unaviable evaluetion-unaviable"
        >
          <span class="no-info-text ">
            <p class="p-no-info">
              No cuenta con evaluaciones disponibles para recomendar.
            </p>
          </span>
        </div>
      </template>
      <template v-else>
        <div class="row d-flex justify-content-start mt-2">
          <div class="col-12 mt-3">
            <div>
              <EvaluationRecommendRow
                v-for="evaluation in recommendedEvaluations"
                :key="`eval-item-${evaluation.studentEvaluationId}`"
                :ref="
                  `evaluation-recommend-row-${evaluation.studentEvaluationId}`
                "
                class="align-left"
                :items-eval="evaluation"
                :discussion-statuses="discussionStatuses"
                :is-submitted="isSubmitted"
                :show-error="showError"
                @on-delete="removeEvaluation(evaluation)"
                @on-discussion-recommended-change="
                  onDiscussionRecommendedChange(evaluation, $event)
                "
                @change-recommendation-comment="
                  onRecommendationCommentChange(evaluation, $event)
                "
              />
            </div>
          </div>
        </div>
      </template>
    </ValidationObserver>
  </div>
</template>

<style scoped src="@/assets/css/component/panel-simple.css"></style>

<script>
import { ValidationObserver } from 'vee-validate';
import alertMixin from '@/mixin/alert.mixin';
import SectionTitle from 'SectionTitle';
import CustomBalloon from 'custom-balloon';
import ActionButton from 'ActionButton';
import studentEvaluationService from '@/modules/student-evaluations/api.js';
import EvaluationInformationRow from './EvaluationInformationRow';
import { getRejectionReasonsV2 } from '@/modules/common/code.api.js';
import EvaluationRecommendRow from './EvaluationRecommendRow';
import SelectManyEvaluations from './SelectManyEvaluations';
import ErrorComponent from '@/components/common/Error';
import DiscussionStatus from '@/utils/constants/student/discussionStatus';
import { discussionStatuses } from '@/utils/constants/evaluation-discussion/discussionStatusCode';
import { evaluationStatusCodes } from '@/utils/constants/evaluation-discussion/evaluationStatusCodes';

export default {
  name: 'EvaluationInformation',
  mixins: [alertMixin],
  components: {
    ValidationObserver,
    SectionTitle,
    CustomBalloon,
    ActionButton,
    EvaluationInformationRow,
    EvaluationRecommendRow,
    SelectManyEvaluations,
    ErrorComponent,
  },
  props: {
    studentSie: {
      type: String,
      default: '0',
    },
    committeeId: {
      type: String,
      default: '0',
    },
    validate: {
      type: Boolean,
      default: true,
    },
    isSubmitted: {
      type: Boolean,
      default: false,
    },
    collections: {
      type: Object,
      default: () => ({
        discussionStatuses: [],
      }),
    },
    persistedEvaluations: {
      type: Array,
      default: () => [],
    },
    showError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: {
        evaluationDate: null,
        academicYearId: null,
        academicYearDesc: null,
        academicYear: null,
        impedimentChangeFlag: false,
        comment: null,
      },
      evaluations: [],
      evaluationInformationLayout: {
        evaluationsAddedList: [],
        availables: [],
        evaluationInformationData: [],
      },
      selectManyEvaluationsOpened: false,
      rejectionReasons: [],
      allRejectionReasons: [],
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    availables() {
      return this.evaluationInformationLayout.availables.map((x) => ({
        id: x.value,
        name: x.text,
      }));
    },
    evaluationList() {
      return (
        this.evaluationInformationLayout.evaluationInformationData ?? []
      ).filter((x) => x.validForDiscussion);
    },
    selectedEvaluations() {
      return this.evaluationList.map((x) => ({
        id: x.studentEvaluationId,
        name: `${x.evaluationDate} - ${x.disciplineTypeName}`,
      }));
    },
    discussionStatuses() {
      return this.collections.discussionStatuses;
    },
    recommendedEvaluations() {
      const evaluations =
        this.evaluationInformationLayout.evaluationInformationData ?? [];
      return evaluations.filter(
        (x) =>
          x.validForRecommendation &&
          x.evaluationStatusId == evaluationStatusCodes.pending &&
          (x.timeToExpiration <= 90 || x.evaluation?.timeToExpiration <= 90)
      );
    },
    hasRecommendedEvaluations() {
      return this.recommendedEvaluations.length > 0;
    },
  },
  async mounted() {
    if (this.committeeId == 0) {
      await this.loadEvaluations();
      await this.loadRejectionReasons();
    }
  },
  methods: {
    validateEvaluation() {
      this.evaluationInformationLayout.evaluationInformationData.forEach(
        (element) => {
          if (
            element.discussionStatusId == DiscussionStatus.PartialAccepted ||
            element.discussionStatusId == DiscussionStatus.Rejected
          ) {
            if (element.rejectionReasons.length == 0) {
              element.isValid = false;
            } else {
              element.isValid = true;
            }
          }
        }
      );

      this.evaluationInformationLayout.evaluationInformationData = this.evaluationInformationLayout.evaluationInformationData.filter(
        (x) =>
          x.validForDiscussion ||
          (x.validForRecommendation && x.timeToExpiration <= 90)
      );

      this.$emit('add-evaluation-layout', this.evaluationInformationLayout);
    },
    async loadEvaluations(addedRecentlyId = null) {
      const _excludedList = this.evaluationInformationLayout.availables;
      let _addedList = this.evaluationInformationLayout.evaluationsAddedList;

      if (addedRecentlyId > 0) _addedList.push(addedRecentlyId);

      if (_addedList && _addedList.length > 0)
        _addedList = _addedList.map((x) => ({ value: x }));

      await this.getEvaluationInformation(_addedList, _excludedList);
      await this.getAvailablesEvaluations();

      const discussionEvaluations = this.evaluationInformationLayout.evaluationInformationData.filter(
        (x) => x.validForDiscussion
      );

      this.$emit('add-evaluation', discussionEvaluations);
    },
    async removeEvaluation(evaluation) {
      const i = this.evaluationInformationLayout.evaluationInformationData.findIndex(
        (x) => x.studentEvaluationId == evaluation.studentEvaluationId
      );
      evaluation.validForDiscussion = false;
      this.evaluationInformationLayout.evaluationInformationData[
        i
      ] = evaluation;
      if (evaluation.validForRecommendation) {
        this.evaluationInformationLayout.evaluationInformationData = this.evaluationInformationLayout.evaluationInformationData.filter(
          (x) =>
            parseInt(x.studentEvaluationId) !== evaluation.studentEvaluationId
        );
      }

      this.$emit('remove-evaluation', evaluation);
    },
    applyEvaluationSelectedHandler(
      evaluationsAddedList,
      evaluationsExcludedList
    ) {
      this.getEvaluationInformation(
        evaluationsAddedList, //.map((x) => x.value).join(", "),
        evaluationsExcludedList, //.map((x) => x.value).join(", "),
        this.isInitialPostRegistry,
        this.evaluationServiceType != null ? this.evaluationServiceType : 2,
        this.disabled,
        this.$route.params.evaluationDateId
      );
    },
    async getEvaluationInformation(
      evaluationsAddedList,
      evaluationsExcludedList = undefined,
      isInitialPostRegistry,
      evaluationServiceType,
      disabled,
      evaluationDateId
    ) {
      await studentEvaluationService
        .getEvaluationForEligilibility({
          StudentSieID: this.studentSie,
          ComparisonDate: null,
          EvaluationServiceType:
            evaluationServiceType == undefined ? 2 : evaluationServiceType, // 2=additionalEvaluation enum type
          ExcludedEvaluations:
            evaluationsExcludedList != undefined
              ? evaluationsExcludedList.map((x) => x.value).join(', ')
              : '',
          SelectedEvaluations:
            evaluationsAddedList != undefined
              ? evaluationsAddedList.map((x) => x.value).join(', ')
              : '',
          evaluationDateId: evaluationDateId,
          IsInitialPostRegistry: isInitialPostRegistry,
          isDisabled: disabled,
          excludedStatusIds: `${evaluationStatusCodes.excluded}`,
        })
        .then((res) => {
          res.data.forEach((e) => {
            e.editable =
              !e.discussionStatusId ||
              e.discussionStatusId == discussionStatuses.pending
                ? true
                : false;
            e.validForDiscussion = e.validForDiscussion;
            //Vm for Reject section
            e.validForRecommendation =
              !e.validForDiscussion &&
              e.reevaluationRequired &&
              e.evaluationStatusId === evaluationStatusCodes.pending;
            e.rejection = {
              rejectionById: e.rejectionById,
              rejectionComment: e.rejectionComment,
            };
            e.isOpened = false;
            e.isValid = true;
            e.rejectionReasons = [];
            e.isImpedimentEvaluationFlag = false;
          });

          let data = [...res.data];
          let uniqArray = this.$deleteArrayDuplicates(
            data,
            'studentEvaluationId'
          );
          if (
            this.evaluationInformationLayout.evaluationInformationData.length >
            0
          ) {
            const studentEvaluationsIds = this.evaluationInformationLayout.evaluationInformationData.map(
              (f) => f.studentEvaluationId
            );
            const oldData = this.evaluationInformationLayout.evaluationInformationData.map(
              (f) => f
            );
            this.evaluationInformationLayout.evaluationInformationData = uniqArray.map(
              (v) => {
                if (!studentEvaluationsIds.includes(v.studentEvaluationId)) {
                  return v;
                }
                if (
                  oldData.find(
                    (o) => o.studentEvaluationId == v.studentEvaluationId
                  ) != undefined
                ) {
                  return oldData.find(
                    (o) => o.studentEvaluationId == v.studentEvaluationId
                  );
                }
              }
            );
          } else {
            this.evaluationInformationLayout.evaluationInformationData = uniqArray;
          }

          if (this.persistedEvaluations.length > 0) {
            var ids = new Set(
              this.persistedEvaluations.map((d) => d.studentEvaluationId)
            );
            var merged = [
              ...this.persistedEvaluations,
              ...this.evaluationInformationLayout.evaluationInformationData.filter(
                (d) => !ids.has(d.studentEvaluationId)
              ),
            ];

            this.evaluationInformationLayout.evaluationInformationData = merged;
          }

          this.$emit(
            'on-get-evaluations',
            this.evaluationInformationLayout.evaluationInformationData.filter(
              (x) =>
                x.validForDiscussion ||
                (x.validForRecommendation && x.timeToExpiration <= 90)
            )
          );
        })
        .catch((err) => {
          this.response = err;
        });
    },
    async getAvailablesEvaluations() {
      let self = this;
      let model = {
        studentSieId: this.studentSie,
        endDate: '',
        evaluationList: self.evaluationInformationLayout.evaluationsAddedList.join(
          ', '
        ),
        excludedStatusIds: `${evaluationStatusCodes.excluded}`,
      };
      await studentEvaluationService
        .getAvailablesEvaluations(model)
        .then((res) => {
          self.evaluationInformationLayout.availables = res.data || [];
        });
    },
    addEvaluationHandler() {
      const self = this;

      self.$emit('on-evaluation-history-add', this.evaluationList);

      self.$router.push({
        name: 'student-evaluation-history-add',
        query: {
          from: `/student/evaluationdiscuss/${this.studentSie}`,
          studentSieId: this.studentSie,
        },
      });
    },
    openCloseSelectManyEvaluations() {
      this.selectManyEvaluationsOpened = !this.selectManyEvaluationsOpened;
    },
    async onContinueHandler(selectedItems, removedItems) {
      const removedIds = new Set(removedItems.map((d) => parseInt(d.id)));

      let modified = this.evaluationInformationLayout.evaluationInformationData.map(
        (item) => {
          if (removedIds.has(item.studentEvaluationId)) {
            item.validForDiscussion = false;
          }
          return item;
        }
      );

      var ids = new Set(selectedItems.map((d) => parseInt(d.id)));

      modified = this.evaluationInformationLayout.evaluationInformationData.map(
        (item) => {
          if (ids.has(item.studentEvaluationId)) {
            item.validForDiscussion = true;
          }
          return item;
        }
      );

      this.evaluationInformationLayout.evaluationInformationData = modified;

      this.openCloseSelectManyEvaluations();
    },
    onDetermineChange(evaluation, determineOption) {
      evaluation.determines = determineOption;

      let elementIndex = this.evaluationInformationLayout.evaluationInformationData.findIndex(
        (obj) => obj.studentEvaluationId == evaluation.studentEvaluationId
      );

      this.evaluationInformationLayout.evaluationInformationData[
        elementIndex
      ].isImpedimentEvaluationFlag = determineOption;

      this.evaluationInformationLayout.evaluationInformationData[
        elementIndex
      ].determines = determineOption;

      this.evaluationInformationLayout.evaluationInformationData[
        elementIndex
      ].eligibilityFlag = determineOption ? '1' : '0';

      var itemsWithDetermines = this.evaluationInformationLayout.evaluationInformationData.filter(
        (x) => x.determines === true
      ).length;

      //reset reasons
      this.rejectionReasons = this.allRejectionReasons;

      this.$emit('on-show-elegibility-determination', itemsWithDetermines);
    },
    async loadRejectionReasons() {
      const { data } = await getRejectionReasonsV2();
      this.rejectionReasons = [...data];
      this.allRejectionReasons = [...data];
    },
    onRemoveRejection(evaluation, selectedReason) {
      let reason = this.rejectionReasons.find((x) => x.id == selectedReason.id);
      reason.comment = selectedReason.comment;

      let elementIndex = this.evaluationInformationLayout.evaluationInformationData.findIndex(
        (obj) => obj.studentEvaluationId == evaluation.studentEvaluationId
      );

      this.evaluationInformationLayout.evaluationInformationData[
        elementIndex
      ].rejectionReasons.push(reason);

      let filteredList = this.rejectionReasons.filter(
        (x) => x.id !== selectedReason.id
      );

      this.rejectionReasons = filteredList;
    },
    async onAddRejection(evaluation, id) {
      let reason = this.allRejectionReasons.find((x) => x.id == id);

      this.rejectionReasons.push(reason);

      this.rejectionReasons = this.rejectionReasons.sort((a, b) => a.id - b.id);

      let filteredList = evaluation.rejectionReasons.filter((x) => x.id !== id);

      let elementIndex = this.evaluationInformationLayout.evaluationInformationData.findIndex(
        (obj) => obj.studentEvaluationId == evaluation.studentEvaluationId
      );

      this.evaluationInformationLayout.evaluationInformationData[
        elementIndex
      ].rejectionReasons = filteredList;
    },
    onDiscussionStatusChange(evaluation, discussionStatus) {
      let elementIndex = this.evaluationInformationLayout.evaluationInformationData.findIndex(
        (obj) => obj.studentEvaluationId == evaluation.studentEvaluationId
      );

      this.evaluationInformationLayout.evaluationInformationData[
        elementIndex
      ].discussionStatusId = discussionStatus ? discussionStatus.id : null;
    },
    onDiscussionRecommendedChange(evaluation, recommended) {
      let elementIndex = this.evaluationInformationLayout.evaluationInformationData.findIndex(
        (obj) => obj.studentEvaluationId == evaluation.studentEvaluationId
      );

      this.evaluationInformationLayout.evaluationInformationData[
        elementIndex
      ].recommended = recommended;
    },
    onRecommendationCommentChange(evaluation, comment) {
      let elementIndex = this.evaluationInformationLayout.evaluationInformationData.findIndex(
        (obj) => obj.studentEvaluationId == evaluation.studentEvaluationId
      );

      this.evaluationInformationLayout.evaluationInformationData[
        elementIndex
      ].referralRequestReason = comment;
    },
    onPushComments(evaluation, reasons) {
      let elementIndex = this.evaluationInformationLayout.evaluationInformationData.findIndex(
        (obj) => obj.studentEvaluationId == evaluation.studentEvaluationId
      );

      this.evaluationInformationLayout.evaluationInformationData[
        elementIndex
      ].rejectionReasons = reasons;
    },
  },
};
</script>

<style scoped>
.custom-panel-row-without-selector {
  background: #fafbfa 0% 0% no-repeat padding-box;
}
.no-info {
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-left-style: solid;
  border-color: #e8e8e8;
  border-width: 0;
}
.no-info-text {
  text-align: center;
  font-family: Lato;
  font-size: 16px;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}
.no-info-icon {
  color: #727272;
  font-size: 32px;
}
.bg-gray {
  background: #f2f2f2;
}
.balloon-container.pending {
  background-color: #fff8e3;
}
.balloon-container.recommend {
  background-color: #ffebeb;
}
.align-left {
  margin-left: auto;
}

.evaluetion-unaviable {
  margin-left: 3px;
  padding-top: 0px;
  width: 100%;
  height: 103px;
}

.resizer {
  width: 104%;
}
.container-info-unaviable {
  background-color: white;
  border-radius: 5px;
  padding: 16px;
}
.p-no-info {
  padding-top: 15px;
}
@media only screen and (min-width: 600px) {
  .resizer {
    width: 50%;
    margin-left: auto;
  }

  .align-left {
    margin-left: 0px;
  }
  .evaluetion-unaviable {
    margin-left: 3px;
    width: 100%;
  }
  .p-no-info {
    padding-top: 0px;
  }
  .evaluetion-unaviable {
    margin-left: 3px;
    padding-top: 17px;
    width: 100%;
    height: 60px;
  }
}
</style>
